export default __webpack_public_path__ + "static/media/NT_PRE_NOV1.ce47f674.png";